// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"4a7e528d","100":"2b1df6d6","109":"450a9f22"}[chunkId] + ".chunk.js";
};